export default __webpack_public_path__ + "0a74e3e73f03795f68eb6f20da6a5cfd.png";